import { gql } from 'graphql-request';

export const USER_ORGANIZATION_FIELDS = gql`
  fragment UserOrganizationFields on UserOrganizationDto {
    userOrganizationId
    userId
    organizationId
    role
    status
    createdAt
    updatedAt
    hasSeat
    seatType
    seatAssignmentId
    organization {
      organizationId
      name
      description
    }
    user {
      userId
      firstName
      lastName
      email
    }
  }
`;

export const getUserOrganizations = gql`
  query getUserOrganizations($userId: String!) {
    getUserOrganizations(userId: $userId) {
      ...UserOrganizationFields
    }
  }
  ${USER_ORGANIZATION_FIELDS}
`;

export const getUserOrganizationsWithDeleted = gql`
  query getUserOrganizationsWithDeleted($userId: String!) {
    getUserOrganizationsWithDeleted(userId: $userId) {
      ...UserOrganizationFields
      deletedAt
    }
  }
  ${USER_ORGANIZATION_FIELDS}
`;

export const getOrganizationUsers = gql`
  query getOrganizationUsers($organizationId: String!) {
    getOrganizationUsers(organizationId: $organizationId) {
      ...UserOrganizationFields
    }
  }
  ${USER_ORGANIZATION_FIELDS}
`;

export const addUserToOrganization = gql`
  mutation addUserToOrganization($input: UserOrganizationCreateInput!) {
    addUserToOrganization(input: $input) {
      ...UserOrganizationFields
    }
  }
  ${USER_ORGANIZATION_FIELDS}
`;

export const updateUserOrganizationRole = gql`
  mutation updateUserOrganizationRole($input: UserOrganizationUpdateInput!) {
    updateUserOrganizationRole(input: $input) {
      ...UserOrganizationFields
    }
  }
  ${USER_ORGANIZATION_FIELDS}
`;

export const removeUserFromOrganization = gql`
  mutation removeUserFromOrganization($userId: String!, $organizationId: String!) {
    removeUserFromOrganization(userId: $userId, organizationId: $organizationId)
  }
`;

export const restoreUserToOrganization = gql`
  mutation restoreUserToOrganization($userId: String!, $organizationId: String!, $role: UserRole) {
    restoreUserToOrganization(userId: $userId, organizationId: $organizationId, role: $role) {
      ...UserOrganizationFields
    }
  }
  ${USER_ORGANIZATION_FIELDS}
`;

export const leaveOrganization = gql`
  mutation leaveOrganization($organizationId: String!) {
    leaveOrganization(organizationId: $organizationId)
  }
`;

const UserOrganizationGraphQL = {
  queries: {
    getUserOrganizations,
    getUserOrganizationsWithDeleted,
    getOrganizationUsers,
  },
  mutations: {
    addUserToOrganization,
    updateUserOrganizationRole,
    removeUserFromOrganization,
    restoreUserToOrganization,
    leaveOrganization,
  },
};

export default UserOrganizationGraphQL;
